<template>
  <div class="page-wrapper">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
          <ion-title class="fontRoboto">Preview Reservation</ion-title>
          <ion-icon :icon="homeSharp"  class="ion-margin ios" @click="homePage"></ion-icon>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar class="header-toolbar">
        <ion-grid class="title-wrapper ion-no-padding">
          <ion-row>
            <ion-col size-md="8">
              <ion-toolbar class="mobile-header-toolbar">
                <ion-buttons v-slot: start>
                  <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                  <ion-title class="fontRoboto">New Reservation/Preview Reservation</ion-title>
                </ion-buttons>
                
              </ion-toolbar>
            </ion-col>
            <ion-col size-md="4" size-xs="8" class="ion-no-padding">
              <div class="price-tag">
                <p class="ion-no-margin">Available Bal</p>
                <p class="ion-no-margin">&#8377; {{this.amountDetails.clearBalance}}</p>
              </div>
              <div class="price-tag">
                <p class="ion-no-margin">Current Bal</p>
                <p class="ion-no-margin">&#8377; {{this.amountDetails.totalBalance}}</p>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-toolbar>
    </ion-header>
    <ion-content class="review-page" v-if="selectedDay!=null">
      <div class="title-add-wrapper">
        <ion-grid>
          <ion-row class="header-link">
            <ion-col size-md="12" size-xs="12">
              <div class="num-sec">
                <p class="ion-no-margin fontRoboto reg-no">{{vehicle.regNo}}</p>
                <p class="ion-no-margin fontRobotoLight modelName">
                  {{vehicle.make.name}}
                  {{vehicle.model.name}}
                </p>
              </div>
              <div class="clearFix"></div>
            </ion-col>
          </ion-row>
          <ion-row class="add-wrapper">
            <ion-col size-md="10" size-xs="9">
              <img class="loc-img" :src="selectedChargerValue.image" />
              <div class="add-sec">
                <p class="ion-no-margin fontRobotoBold">{{title}}</p>
                <p class="ion-no-margin fontRobotoMedium">{{selectedChargerValue.subTitle}}</p>
                <p class="ion-no-margin fontRoboto">{{selectedChargerValue.detail}}</p>
                <p
                  class="ion-no-margin fontRoboto"
                >Tariff : ₹ {{selectedChargerValue.rate.amount}}{{selectedChargerValue.rate.unit.unit}}</p>
                <p class="ion-no-margin fontRoboto">{{bayName}}, {{portName}}</p>
                <p
                  class="ion-no-margin fontRobotoBold title areaLoc"
                >{{selectedChargerValue.setup.station.name}}<span v-if="selectedChargerValue.setup.station.rating != 0">&nbsp;{{selectedChargerValue.setup.station.rating}}&nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon></span></p>
                <div class="add-sec">
                  <p class="ion-no-margin fontRoboto">
                    {{selectedChargerValue.setup.station.address.line1}},
                    {{selectedChargerValue.setup.station.address.city}},
                    <br />
                    {{selectedChargerValue.setup.station.address.state.name}} -
                    {{selectedChargerValue.setup.station.address.zipcode}}
                  </p>
                </div>
              </div>
              <div class="clearFix"></div>
            </ion-col>
            <ion-col size-md="2" size-xs="3">
              <a v-bind:href="'tel:'+ selectedChargerValue.setup.station.mobile" class="call-img-a">
                <img class="call-img ion-float-end" src="../../assets/card-call.png" />
              </a>
              <img
                @click="googleMapApp()"
                class="map-img ion-float-end"
                src="../../assets/card-map.png"
              />
            </ion-col>
          </ion-row>

          <!-- <ion-row>
            <ion-col>
              <p>Charging Type: {{chargingTypeName}}</p>
            </ion-col>
          </ion-row> -->
        </ion-grid>
      </div>
      
      <div class="charging-type-wrapper">
        <ion-grid>
          <ion-row class>
            <ion-col size-md="6" size-xs="6">
              <p class="ion-no-margin fontRoboto time-title">
                <span class="fontRobotoBold">Charging Type :</span>
              </p>
            </ion-col>
            <ion-col size-md="6" size-xs="6">
              <p
                class="ion-no-margin fontRobotoBold date-title textAlignRight"
              >{{chargingTypeName}}</p>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      
      <div class="time-slot-wrapper">
        <ion-grid>
          <ion-row class>
            <ion-col size-md="6" size-xs="6">
              <p class="ion-no-margin fontRoboto time-title">
                <span class="fontRobotoBold">Start Time :</span>
              </p>
              <p class="ion-no-margin fontRoboto time-title">
                <span class="fontRobotoBold">End Time :</span>
              </p>
            </ion-col>
            <ion-col size-md="6" size-xs="6">
              <p
                class="ion-no-margin fontRobotoBold date-title textAlignRight"
              >{{slotDetails.startTime}}</p>
              <p class="ion-no-margin fontRobotoBold textAlignRight">{{slotDetails.endTime}}</p>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div class="estimation-cost-wrapper">
        <ion-grid>
          <ion-row class>
            <ion-col size-md="6" size-xs="6">
              <p class="ion-no-margin fontRobotoBold price-title">Estimated Cost</p>
            </ion-col>
            <ion-col size-md="6" size-xs="6">
              <p class="ion-no-margin fontRobotoMedium price-value textAlignRight">
                ₹
                {{slotDetails.estimatedCost}}
              </p>
            </ion-col>
          </ion-row>
          <ion-row v-if="displayMessage">
            <ion-col><p class="display-message">{{ descriptionToConfirm }}</p></ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <!-- Below code is restricted user only, this code will not allow to confirm reservation added by vinoth on 19.11.2021 -->
       <!-- <div  class="estimation-cost-wrapper" v-if="animationView === true">
        <ion-grid>
          <ion-row>
              <ion-col  size-md="6" size-xs="6">
              <p  class="ion-margin-top fontRobotoBold price-title">Launching Soon...</p>
          </ion-col>
          <ion-col size-md="6" size-xs="6">
              <img class="ion-no-margin text-center carImage" src="https://devapi.rapidevcharge.com/qrcode/images/123.gif" />
              
          </ion-col>
          </ion-row>
        </ion-grid>
      </div> -->
    </ion-content>
    <ion-footer>
      <ion-button v-if="displayConfirmBtn" expand="full" @click="bookingConfirm()" class="next-btn fontRobotoMedium" v-bind:disabled="disableConfirmBtn">CONFIRM</ion-button>
      <ion-button v-if="displayChargeNowBtn" expand="full" @click="startChargeNow()" class="next-btn fontRobotoMedium" v-bind:disabled="confirmChargeNow">Start Charging</ion-button>
    </ion-footer>
    <!-- Below code is restricted user only, this code will not allow to confirm reservation added by vinoth on 19.11.2021 -->
    <!-- <ion-footer v-if="animationView === false">
      <ion-button expand="full" @click="blockedBookingConfirm()" class="next-btn fontRobotoMedium">CONFIRM</ion-button>
    </ion-footer> -->
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonBackButton, IonTitle, IonContent, IonRow, IonGrid, IonCol, IonFooter, IonSpinner, IonIcon } from '@ionic/vue';

import { Coordiate } from "@/entity/location/corodinate";
import { EVCStationService } from "@/service/evcstation/stations.service";
import { EVCStationReservationService } from "@/service/evcstation/reservation.service";
import { LocalStorage } from "../../data/localstorage";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";
import moment from "moment";
import { EVChargingReservationTypeCode } from '@/entity/station/reservation';
import { cut, homeSharp, star } from 'ionicons/icons';
import { ToastUtils } from "../../util/toast-utils";

export default defineComponent ({
  name: 'confirmBooking',
  components: {
    IonHeader, 
    IonToolbar, 
    IonButtons, 
    IonBackButton, 
    IonTitle, 
    IonContent, 
    IonRow, 
    IonGrid, 
    IonCol, 
    IonFooter, 
    IonSpinner,
    IonIcon
  },
  data() {
    return {
      homeSharp,
      star,
      loaderTab: true,
      selectedDay: null,
      amountDetails: {
        totalBalance: "",
        clearBalance: ""
      },
      selectedChargerValue: {
        rate: {
          amount: "",
          unit: {
            unit: ""
          }
        },
        outlet: {
          output: {
            type: {
              volt: "",
              kwRange: { start: "", end: "" }
            }
          }
        },
        setup: {
          station: {
            name: "",
            address: {
              line3: "",
              state: { name: "" }
            }
          }
        }
      },
      vehicle: {
        regNo: "",
        make: { name: "" },
        model: { name: "" }
      },
      slotDetails: {
        startTime: ""
      },
      confirmpageobj: null,
      selectedMarker: null,
      editReservationPage: null,
      editReservationDetails: null,
      chargingType: null,
      chargingTypeName: "",
      animationView: false,
      title: "",
      chargeNow: '',
      displayChargeNowBtn: false,
      displayConfirmBtn: false,
      confirmChargeNow: false,
      counter: 0,
      disableConfirmBtn: false,
      durationCount: 0,
      displayMessage: false,
      descriptionToConfirm: "",
      bayName: "",
      portName: ""
    }
  },
  async mounted() {
    try {
      this.durationCount = await new EVCStationReservationService().getDisplayDuration();
      this.descriptionToConfirm = this.durationCount.data.additionalinfo;
      this.durationCount = parseInt(this.durationCount.data.description)
      this.selectedMarker = JSON.parse(localStorage.getItem("selectedMarker"));
      this.editReservationPage = localStorage.getItem("editReservationPage");
      this.chargingType = JSON.parse(localStorage.getItem("slotDetails"));
      this.chargeNow = localStorage.getItem('chargeNow');
      if(this.chargeNow) {
        this.displayChargeNowBtn = true;
      } else {
        this.displayConfirmBtn = true;
      }
      if(this.chargingType.chargeType == "TB") {
        this.chargingTypeName = "Time Based";
      } else if(this.chargingType.chargeType == "CB") {
        this.chargingTypeName = "Capacity Based";
      } else if(this.chargingType.chargeType == "AB") {
        this.chargingTypeName = "Amount Based";
      } else if(this.chargingType.chargeType == "UB") {
        this.chargingTypeName = "Unit Based";
      }
      this.editReservationDetails = JSON.parse(
        localStorage.getItem("editReservationDetails")
      );
      if (this.editReservationPage) {
        this.editdataFormation();
      } else {
        this.dataFormation();
      }
      this.startCountdown(this.durationCount);
    } catch(error) {
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);

    }
    
  },
  methods: {
    homePage() {
      let userRole = localStorage.getItem("user.roleId")
      if(userRole == 2) {
        this.$router.push("/customer/reservation")
      }
    },
    navigatePreviousPage() {
      this.$router.go(-1)
    },
    startCountdown(seconds) {
      this.counter = seconds;

      var interval = setInterval(() => {
        this.counter--;

        if (this.counter <= 0) {
          // The code here will run when
          // the timer has reached zero.
          clearInterval(interval);
          
          if(this.disableConfirmBtn == false && this.confirmChargeNow == false) {
            this.disableConfirmBtn = true;
            this.confirmChargeNow = true;
            this.displayMessage = true;
          }
          
        }
      }, 1000);
    },
    getTitle(title) {
      let cusTitle = title.split(",")[0];
      return cusTitle;
    },
    dataFormation() {
      this.amountDetails = JSON.parse(localStorage.getItem("amountDetails"));
      this.selectedChargerValue = JSON.parse(
        localStorage.getItem("selectedChargerValue")
      );
      this.title = (this.selectedChargerValue.title).split(",")[0];
      this.vehicle = JSON.parse(localStorage.getItem("vehicle"));
      this.slotDetails = JSON.parse(localStorage.getItem("slotDetails"));
      this.slotDetails.startTime = moment(
        this.slotDetails.startTime,
        "DD.MM.YYYY HH:mm"
      ).format("DD/MMM/YYYY HH:mm");
      this.slotDetails.endTime = moment(
        this.slotDetails.endTime,
        "DD.MM.YYYY HH:mm"
      ).format("DD/MMM/YYYY HH:mm");
      this.bayName = this.selectedChargerValue.bayDetails.bayName;
      this.portName = this.selectedChargerValue.bayDetails.connectorName;
      this.confirmpageobj = {
        selectedMarker: JSON.parse(localStorage.getItem("selectedMarker")),
        opensAt: localStorage.getItem("opensAt"),
        closesAt: localStorage.getItem("closesAt"),
        teleUrl: localStorage.getItem("teleUrl")
      };
      var todayDate = new Date();
      if (
        this.GetFormattedDate(new Date(this.slotDetails.selectedDate)) ===
        this.GetFormattedDate(todayDate)
      ) {
        this.selectedDay = "Today";
      } else {
        this.selectedDay = this.GetFormattedDate(
          new Date(this.slotDetails.selectedDate)
        );
      }
      this.loaderTab = false;
    },    
    editdataFormation() {
      this.amountDetails = JSON.parse(localStorage.getItem("amountDetails"));
      this.selectedMarker = this.editReservationDetails.station;
      this.vehicle = this.editReservationDetails.vehicle;
      this.selectedChargerValue = this.editReservationDetails.gun;
      this.slotDetails = JSON.parse(localStorage.getItem("slotDetails"));
      var todayDate = new Date();
      if (
        this.GetFormattedDate(new Date(this.slotDetails.selectedDate)) ===
        this.GetFormattedDate(todayDate)
      ) {
        this.selectedDay = "Today";
      } else {
        this.selectedDay = this.GetFormattedDate(
          new Date(this.slotDetails.selectedDate)
        );
      }
    },
    GetFormattedDate(date) {
      var monthArry = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      var month = monthArry[date.getMonth()];
      var day = date.getDate();
      var year = date.getFullYear();
      return day + " " + month + " " + year;
    },
    googleMapApp() {
      if (
        /* if we're on iOS, open in Apple Maps */
        navigator.platform.indexOf("iPhone") != -1 ||
        navigator.platform.indexOf("iPod") != -1 ||
        navigator.platform.indexOf("iPad") != -1
      )
        window.open(
          "maps://maps.google.com/maps?daddr=" +
            this.selectedChargerValue.setup.station.coordinate.latitude +
            "," +
            this.selectedChargerValue.setup.station.coordinate.longitude +
            "&amp;ll="
        );
      /* else use Google */ else
        window.open(
          "https://maps.google.com/maps?daddr=" +
            this.selectedChargerValue.setup.station.coordinate.latitude +
            "," +
            this.selectedChargerValue.setup.station.coordinate.longitude +
            "&amp;ll="
        );
    },
    async bookingConfirm() {
      let reservation;
      this.loaderTab = true;
      try {
        if (this.editReservationPage) {
          if (this.slotDetails.timeBasedBooking) {
            reservation = await new EVCStationReservationService().changeReservationForChargingVehicleWithStationGunBetweenAtCostForUser(
              this.editReservationDetails,
              this.vehicle,
              this.selectedChargerValue,
              new Date(this.slotDetails.poststartTime).toISOString(),
              new Date(this.slotDetails.postendTime).toISOString(),
              this.slotDetails.estimatedCost,
              new LocalStorage().user
            );
          } else {
            reservation = await new EVCStationReservationService().changeReservationForChargingVehicleUptoPercentageBetweenAtCostForUser(
              this.editReservationDetails,
              this.vehicle,
              this.selectedChargerValue,
              this.slotDetails.percentNumber,
              new Date(this.slotDetails.poststartTime).toISOString(),
              new Date(this.slotDetails.postendTime).toISOString(),
              this.slotDetails.estimatedCost,
              new LocalStorage().user
            );
          }
        } else {
          if (this.slotDetails.chargeType == EVChargingReservationTypeCode.ChargeForDuration) {
            reservation = await new EVCStationReservationService().reserveToChargeVehicleWithStationGunBetweenAtCostForUser(
              this.vehicle,
              this.selectedChargerValue,
              new Date(this.slotDetails.poststartTime).toISOString(),
              new Date(this.slotDetails.postendTime).toISOString(),
              this.slotDetails.estimatedCost,
              new LocalStorage().user
            );
          } else if (this.slotDetails.chargeType == EVChargingReservationTypeCode.ChargeUptoCapacity) {
            reservation = await new EVCStationReservationService().reserveToChargeVehicleUptoPercentageBetweenAtCostForUser(
              this.vehicle,
              this.selectedChargerValue,
              this.slotDetails.percentNumber,
              new Date(this.slotDetails.poststartTime).toISOString(),
              new Date(this.slotDetails.postendTime).toISOString(),
              this.slotDetails.estimatedCost,
              new LocalStorage().user
            );
          } else if (this.slotDetails.chargeType == EVChargingReservationTypeCode.ChargeForUnit) {
            reservation = await new EVCStationReservationService().reserveToChargeVehicleByUnitBasedAtCostForUser(
              this.vehicle,
              this.selectedChargerValue,
              this.slotDetails.unitNumber,
              new Date(this.slotDetails.poststartTime).toISOString(),
              new Date(this.slotDetails.postendTime).toISOString(),
              this.slotDetails.estimatedCost,
              new LocalStorage().user
            );
          } else if (this.slotDetails.chargeType == EVChargingReservationTypeCode.ChargeForAmount) {
            reservation = await new EVCStationReservationService().reserveToChargeVehicleByAmountBasedAtCostForUser(
              this.vehicle,
              this.selectedChargerValue,
              this.slotDetails.amountNumber,
              new Date(this.slotDetails.poststartTime).toISOString(),
              new Date(this.slotDetails.postendTime).toISOString(),
              this.slotDetails.estimatedCost,
              new LocalStorage().user
            );
          }
        }
        this.loaderTab = false;
        if (reservation.refNo) {
          localStorage.setItem("refNumber", reservation.refNo);
          localStorage.setItem("reservationInfo", JSON.stringify( reservation ));
          this.$router.push({ name: "resConfirm" });
        }
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
     
    },
    
    blockedBookingConfirm() {
      this.animationView = true;
      setTimeout(() => {
        this.$router.replace("/customer/reservation");
      },5000)
    },
    async startChargeNow() {
      this.loaderTab = true;
      this.confirmChargeNow = true;
      try {
        let reservation;
        if (this.slotDetails.chargeType == EVChargingReservationTypeCode.ChargeForDuration) {
          reservation = await new EVCStationReservationService().startChargeNowByTime(
            this.vehicle,
            this.selectedChargerValue,
            new Date(this.slotDetails.poststartTime).toISOString(),
            new Date(this.slotDetails.postendTime).toISOString(),
            this.slotDetails.estimatedCost,
            new LocalStorage().user
          );
        } else if (this.slotDetails.chargeType == EVChargingReservationTypeCode.ChargeUptoCapacity) {
          reservation = await new EVCStationReservationService().startChargeNowByCapacity(
            this.vehicle,
            this.selectedChargerValue,
            this.slotDetails.percentNumber,
            new Date(this.slotDetails.poststartTime).toISOString(),
            new Date(this.slotDetails.postendTime).toISOString(),
            this.slotDetails.estimatedCost,
            new LocalStorage().user
          );
        } else if (this.slotDetails.chargeType == EVChargingReservationTypeCode.ChargeForUnit) {
          reservation = await new EVCStationReservationService().startChargeNowByUnit(
            this.vehicle,
            this.selectedChargerValue,
            this.slotDetails.unitNumber,
            new Date(this.slotDetails.poststartTime).toISOString(),
            new Date(this.slotDetails.postendTime).toISOString(),
            this.slotDetails.estimatedCost,
            new LocalStorage().user
          );
        } else if (this.slotDetails.chargeType == EVChargingReservationTypeCode.ChargeForAmount) {
          reservation = await new EVCStationReservationService().startChargeNowByAmount(
            this.vehicle,
            this.selectedChargerValue,
            this.slotDetails.amountNumber,
            new Date(this.slotDetails.poststartTime).toISOString(),
            new Date(this.slotDetails.postendTime).toISOString(),
            this.slotDetails.estimatedCost,
            new LocalStorage().user
          );
        }
        this.loaderTab = false;
        if (reservation.refNo) {
          localStorage.removeItem("duration");
          this.$router.push({
            name: "myReservationView",
            params: { bookingId: reservation.bookingId },
          });
        }
      } catch(error) {
        // let er = JSON.parse(error);
        this.loaderTab = false;
        this.confirmChargeNow = false;
        // new ToastUtils().presentToast(er.errors[0].detail);
        // new ToastUtils().presentToast(error.response.data.errors[0].detail);
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    }
  }
})
</script>

<style scoped>
.ios ion-icon {
  color: white;
  position: relative;
  left:70%;
}
.display-message {
  color: red;
  font-weight: bold;
  font-family: "Roboto Bold";
}
.page-wrapper {
  background: #f4f5f9;
}

ion-content {
  --background: #f4f5f9;
  position: absolute;
  --padding-bottom: 108px;
  --padding-top: 54px;
}

ion-footer {
  position: fixed;
  width: 100%;
  bottom: 0;
}
.num-sec .reg-no {
  text-transform: uppercase;
}
.textAlignRight {
  text-align: right;
}

/* Title */
@media (max-width: 768px) {
  .review-page {
    /* Status bar height on iOS 11.0 */
    top: constant(safe-area-inset-top);
    /* Status bar height on iOS 11+ */
    top: env(safe-area-inset-top);
  }

  .title-add-wrapper .add-wrapper .loc-img {
    margin-right: 13px !important;
  }

  .header-toolbar,
  .mobile-header-toolbar {
    --background: #21b24b;
  }

  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }

  .mobile-header-toolbar ion-title {
    color: #fff;
  }

  .mobile-header-toolbar ion-buttons {
    color: #fff;
    --background: #fff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
  .title-add-wrapper {
    padding-left: 18px !important;
    padding-right: 24px !important;
  }

  .paddingRight {
    padding-right: 0px !important;
  }
}

@media (min-width: 768px) {
  .title-wrapper .price-tag {
    float: right;
  }

  .title-wrapper .price-tag {
    display: inline-block;
    margin-right: 20px;
    padding-top: 5px;
    padding-bottom: 7px;
  }

  .title-wrapper .price-tag p:first-child,
  .title-wrapper .price-tag p:last-child,
  .title-wrapper ion-title {
    font-family: "Roboto";
    font-size: 15px;
    color: #495057;
  }

  .title-wrapper ion-title {
    padding-top: 10px;
  }

  .title-wrapper .price-tag p:last-child {
    font-family: "Roboto Medium";
  }
}

/* Title */

.fontRobotoBold {
  font-family: "Roboto Bold";
}

.fontRobotoMedium {
  font-family: "Roboto Medium";
}

.fontRobotoLight {
  font-family: "Roboto light";
}

.fontRoboto {
  font-family: "Roboto";
}

.paddingZero {
  padding: 0;
}

.paddingGrid {
  margin: -5px;
}

.clearFix {
  clear: both;
}

.title-add-wrapper {
  min-height: 171px;
  margin-top: 9px;
  margin-bottom: 7px;
}

.header-link .car-img {
  float: left;
  width: 33px;
  height: 18px;
  margin-right: 16px;
  margin-top: 25px;
}

.add-sec {
  font-size: 14px;
}

.header-link .num-sec {
  float: left;
  margin-top: 18px;
  font-size: 14px;
}

.header-link .num-sec .modelName {
  color: #000000;
  opacity: 0.5;
}

.title-add-wrapper,
.time-slot-wrapper,
.estimation-cost-wrapper,
.charging-type-wrapper {
  padding-left: 25px;
  padding-right: 35px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  opacity: 1;
}
.charging-type-wrapper {
  min-height: 77px;
  padding: 20px 21px 10px 18px;
  font-size: 14px;
  color: #202020;
  margin-bottom: 8px;
}
.time-slot-wrapper {
  min-height: 77px;
  padding: 20px 21px 12px 18px;
  font-size: 14px;
  color: #202020;
}

.estimation-cost-wrapper {
  min-height: 60px;
  margin-top: 10px;
  padding: 18px 18px 20px 18px;
  font-size: 14px;
}

.estimation-cost-wrapper .price-title {
  font-size: 14px;
  color: #21315d;
  padding-top: 3px;
}

.estimation-cost-wrapper .price-value {
  font-size: 18px;
  color: #21b24b;
}
.charging-type-wrapper .time-title {
  color: #21315d;
  margin-bottom: 11px;
}
.charging-type-wrapper .date-title {
  /* color: #21315d; */
  margin-bottom: 11px;
}
.time-slot-wrapper .time-title {
  color: #21315d;
  margin-bottom: 11px;
}

.time-slot-wrapper .date-title {
  margin-bottom: 11px;
}

.title-add-wrapper .add-wrapper {
  margin-top: 13px;
  margin-bottom: 18px;
}

.title-add-wrapper .title {
  font-size: 15px;
  color: #21315d;
  opacity: 1;
}

.areaLoc {
  opacity: 0.5;
  margin-top: 7px;
}

.title-add-wrapper .title {
  margin-bottom: 4px;
}

.title-add-wrapper .subtitle {
  font-size: 14px;
  color: #000000;
  opacity: 0.5;
}

.title-add-wrapper .call-img {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 0;
  top: 0;
}

.title-add-wrapper .add-wrapper .loc-img {
  width: 21px;
  height: 24px;
  float: left;
  margin-right: 22px;
}

.title-add-wrapper .add-wrapper .add-sec {
  float: left;
}

.title-add-wrapper .add-wrapper .add-sec .address {
  width: 167px;
  height: 51px;
  color: #202020;
  opacity: 1;
  font-size: 13px;
  margin-bottom: 7px;
}

.title-add-wrapper .add-wrapper .add-sec .timeArea {
  color: #313131;
  opacity: 1;
  font-size: 13px;
}

.title-add-wrapper .add-wrapper .add-sec .timeArea span {
  color: #21b24b;
}

.title-add-wrapper .add-wrapper .distance {
  color: #d66c6c;
  opacity: 1;
  margin-bottom: 9px;
  font-size: 14px;
}

.title-add-wrapper .add-wrapper .map-img {
  width: 45px;
  height: 45px;
  position: absolute;
  right: 0;
  bottom: 0;
}

.next-btn {
  height: 52px;
  --background: #21b24b;
  /* opacity: 1; */
  font-size: 17px;
  color: #ffffff;
  text-transform: uppercase;
  margin: 0;
}

.next-btn img {
  position: absolute;
  right: 24px;
}
</style>